module.exports = __webpack_public_path__ + "img/ICONO16.ed4ff235.png";